import { render, staticRenderFns } from "./DemoTest.vue?vue&type=template&id=9dd17652&"
import script from "./DemoTest.vue?vue&type=script&lang=js&"
export * from "./DemoTest.vue?vue&type=script&lang=js&"
import style0 from "./DemoTest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports